import React from 'react';
import { Route } from 'react-router-dom';
import AllowRole from 'src/components/AllowRole';
import EditIndicatorPage from 'src/pages/indicators/EditIndicatorPage';
import ListIndicatorsPage from 'src/pages/indicators/ListIndicatorsPage';
import ViewIndicatorPage from 'src/pages/indicators/ViewIndicatorPage';

export default function IndicatorsRoutes() {
	return (
		<>
			<Route path='/indicadores' element={<AllowRole role={'user'} />}>
				<Route path='listar' element={<ListIndicatorsPage />} />
				<Route path='edit/:dashboard_id' element={<EditIndicatorPage />} />
				<Route path='view/:dashboard_id' element={<ViewIndicatorPage />} />
			</Route>
		</>
	);
}
